"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldTooltipClose = exports.isOverlapping = exports.isCursorOver = void 0;
var TOOLTIP_BUFFER_SIZE = 50;
/**
 * Detect if a mouseevent occurred within a given rectangle of UI coordinates
 **/

var isCursorOver = function isCursorOver(boundingClientRect, mouseEvent) {
  var top = boundingClientRect.top,
      bottom = boundingClientRect.bottom,
      left = boundingClientRect.left,
      right = boundingClientRect.right;
  var X = mouseEvent.clientX,
      Y = mouseEvent.clientY;
  return X >= left && X <= right && Y <= bottom && Y >= top;
};
/**
 * Does `rect1` overlap `rect2`?
 *
 * Note that overlaps of less than 1px are ignored, to prevent Tethers that are visually flush from
 * being considered "overlapping" when Tether adjusts them to align with display pixels.
 *
 * @param {Object} rect1
 * @param {Object} rect2
 * @returns {boolean}
 **/


exports.isCursorOver = isCursorOver;

var isOverlapping = function isOverlapping(rect1, rect2) {
  return rect1.top + 1 < rect2.bottom && rect2.top + 1 < rect1.bottom && rect1.left + 1 < rect2.right && rect2.left + 1 < rect1.right;
};
/**
 * Grows each edge of `originalRect` outward toward `magnetRect` by `bufferSize`. Used to determine
 * the "cursor space" between a tooltip target and the tooltip itself.
 *
 * @param {Object} originalRect
 * @param {Object} magnetRect
 * @param {number} bufferSize
 * @return {Object}
 */


exports.isOverlapping = isOverlapping;

var addBufferToRect = function addBufferToRect(originalRect, magnetRect, bufferSize) {
  var bufferedRect = {
    top: originalRect.top,
    right: originalRect.right,
    bottom: originalRect.bottom,
    left: originalRect.left
  };

  if (originalRect.top > magnetRect.top) {
    bufferedRect.top = Math.max(magnetRect.top, originalRect.top - bufferSize);
  }

  if (originalRect.bottom < magnetRect.bottom) {
    bufferedRect.bottom = Math.min(magnetRect.bottom, originalRect.bottom + bufferSize);
  }

  if (originalRect.left > magnetRect.left) {
    bufferedRect.left = Math.max(magnetRect.left, originalRect.left - bufferSize);
  }

  if (originalRect.right < magnetRect.right) {
    bufferedRect.right = Math.min(magnetRect.right, originalRect.right + bufferSize);
  }

  return bufferedRect;
};
/**
 * Determine if a tooltip should close, given the `targetRect`, `tooltipRect`, and the originating
 * `mouseEvent`.
 *
 * @param {Object} targetRect
 * @param {Object} tooltipRect
 * @param {MouseEvent} mouseEvent
 * @return {boolean}
 **/


var shouldTooltipClose = function shouldTooltipClose(targetRect, tooltipRect, mouseEvent) {
  if (isCursorOver(tooltipRect, mouseEvent)) return false;
  var bufferedTarget = addBufferToRect(targetRect, tooltipRect, TOOLTIP_BUFFER_SIZE);
  if (isCursorOver(bufferedTarget, mouseEvent)) return false;
  return true;
};

exports.shouldTooltipClose = shouldTooltipClose;